import { queryOptions } from '@tanstack/react-query';
import { getSurveyChartFunction } from './getSurveyChartQueryFunction';
import { GetSurveyChartQueryParamsType } from './getSurveyChartQuery.type';

export const getSurveyChartQueryOptions = (
  params: GetSurveyChartQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['SurveyChart', params],
    queryFn: () => getSurveyChartFunction(params),
  });
};
